import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const TARGET = new Date("2027-04-19T00:00:00-05:00").getTime();

const UNITS = [
  { key: "days", label: "Days" },
  { key: "hours", label: "Hours" },
  { key: "minutes", label: "Minutes" },
  { key: "seconds", label: "Seconds" },
];

const calc = () => {
  const distance = Math.max(0, TARGET - Date.now());
  return {
    days: Math.floor(distance / 86400000),
    hours: Math.floor((distance % 86400000) / 3600000),
    minutes: Math.floor((distance % 3600000) / 60000),
    seconds: Math.floor((distance % 60000) / 1000),
  };
};

const Flip = ({ value }) => {
  const text = String(value).padStart(2, "0");
  return (
    <span className="font-serif-lux relative flex h-[1.3em] items-center justify-center overflow-hidden text-[2.1rem] sm:text-[3.4rem] md:text-[5.2rem]">
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.span
          key={text}
          initial={{ y: "70%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "-70%", opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="leading-none text-[color:var(--champagne)]"
          style={{ fontVariantNumeric: "lining-nums tabular-nums" }}
        >
          {text}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};

const Countdown = () => {
  const [time, setTime] = useState(calc);

  useEffect(() => {
    const id = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="grid w-full max-w-[860px] grid-cols-4 gap-2 sm:gap-5 md:gap-6 mx-auto"
      data-testid="countdown-clock"
    >
      {UNITS.map((unit, i) => (
        <div
          key={unit.key}
          className="time-ring"
          style={{ animationDelay: `${i * 0.4}s` }}
          data-testid={`countdown-${unit.key.toLowerCase()}`}
        >
          <Flip value={time[unit.key]} />
          <span className="mt-2 md:mt-3 text-[0.45rem] sm:text-[0.58rem] md:text-[0.62rem] tracking-[0.22em] sm:tracking-[0.25em] uppercase text-[color:var(--muted)]">
            {unit.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default Countdown;
